import ContentLoader from "react-native-easy-content-loader";

import { useAppTheme } from "../../../useAppTheme";

type Props = {
	width: number;
	height: number;
	borderRadius?: number;
};

export const ImageSkeleton = ({ width, height, borderRadius }: Props) => {
	const theme = useAppTheme();

	return (
		// @ts-expect-error react-native-easy-content-loader has no types
		<ContentLoader
			active
			title={false}
			pRows={1}
			pHeight={height}
			pWidth={width}
			paragraphStyles={{
				borderRadius: borderRadius ?? theme.roundness,
				overflow: "hidden",
				alignSelf: "center",
			}}
			containerStyles={{
				paddingHorizontal: 0,
			}}
		/>
	);
};
